import React from 'react';
import { AdminRouteName } from '../../CONSTANTS';

import RepaymentTableRecords from '../RepaymentTableRecords';

const DueRepayments = () => (
  <RepaymentTableRecords tabStatus="DUE" defaultUrl={AdminRouteName.dueRepaymentRoute} toggleStorageId="due-repayment-table-col" hasNameAndImage permissionName="can-view-due-repayments" />
);
export default DueRepayments;
